

const ListComponent = ({MenuCategoryList, onListItemClick,demo}) => {


    return (
        <div className="category_list">
<ul className="category-ul">
    {MenuCategoryList && MenuCategoryList.length > 0  &&  MenuCategoryList.map((category) => (
      <li key={category.category_id} className="category-item" onClick={()=>onListItemClick(category.category_id, category.category_name)}>
        <div className="category-content">
         <img
  width={16}
  height={16}
  src={
    !category.category_image_url ||
    category.category_image_url === "null"
      ? demo
      : category.category_image_url
  }
  alt=""
  className="category-image"
  onError={(e) => {
    e.target.onerror = null;   // stop loop
    e.target.src = demo;       // fallback
  }}
/>

          <span className="category-name">{category.category_name}</span>
        </div>
      </li>
    ))}
  </ul>
                </div>

    )
}

export default ListComponent;